module.exports = __webpack_public_path__ + "static/media/street-art-03.f0b4750e.png";